import dayjs from 'dayjs'
import Timezone from 'dayjs/plugin/timezone'
import Utc from 'dayjs/plugin/utc'
dayjs.extend(Utc)
dayjs.extend(Timezone)
/**
 * 获取当天0点时间
 */
export function getTodayDate(): Date {
  return new Date(new Date().toLocaleDateString())
}

export function convertTZ(date:string|Date, tzString:string):Date {
  return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));
}

/**
 * 获取周
 */
export function getWeek(val: Date) {
  const datetime = new Date(val)
  const weekOfDay = datetime.getDay() == 0 ? 7 : datetime.getDay()
  switch (weekOfDay) {
    case 1:
      return 'MON'
    case 2:
      return 'TUE'
    case 3:
      return 'WED'
    case 4:
      return 'THU'
    case 5:
      return 'FRI'
    case 6:
      return 'SAT'
    case 7:
      return 'SUN'
  }
}

/**
 * 获取开始日期和结束日期范围内的所有日期
 * @param startTime 开始日期
 * @param endTime 结束日期
 */
export function getWeekDate(startTime:Date,endTime:Date) {
  const bd = new Date(startTime),be = new Date(endTime);
  const bdTime = bd.getTime(), beTime = be.getTime(),diff = beTime - bdTime;
  const arr = [];
  for(let i=0; i<= diff; i+=86400000){
    const ds = new Date(bdTime+i)
    const mounth = (new Date(ds).getMonth() + 1 < 10) ? '0' + (new Date(ds).getMonth() + 1) : (new Date(ds).getMonth() + 1)
    const day = (new Date(ds).getDate() < 10) ? '0' + new Date(ds).getDate() : new Date(ds).getDate()
    arr.push((ds.getFullYear())+'-'+ mounth +'-'+ day)
  }
  return arr
}

export function getThisMonday(): Date {
  const today = getTodayDate()
  // 周日算作当周最后一天
  const day = today.getDay() == 0 ? 7 : today.getDay()
  today.setDate(today.getDate() - day + 1)
  return today
}

/**
 * 通过dayjs format时间
 * @param date
 * @param format
 * @param isTimeZoneResetChina 是否重置时间为国内时间（例：如果为true,当设置时间为9点，若在非亚洲地区会设置成上海时区的9点）
 */
export function timeFormat(date: string|Date, format: string,isTimeZoneResetChina = false): string {
  let target
  if(date instanceof Date){
    target = date
  }else {
    target = new Date(date)
  }
  if(dayjs.tz.guess().toLowerCase().indexOf('asia') === -1){
    const tDay = target.getDate()
    const tHour = target.getHours()
    const timezoneDate = convertTZ(target,'Asia/Shanghai')
    timezoneDate.setDate(tDay)
    timezoneDate.setHours(tHour)
    return dayjs(timezoneDate).format(format)
  }else {
    return dayjs(target).format(format)
  }
}

/**
 * format流内显示的时间
 * 5分钟内显示为刚刚
 * 1小时内显示为 xx分前
 * 当天显示时分
 * 当年内显示月日 时分
 * 其余显示年月日 时分
 * @param date
 */
export function getFlowDateText(date: string): string {
  const target = new Date(date)
  const now = new Date()
  const diff = (now.getTime() - target.getTime()) / 1000
  if (diff < 60 * 5 && diff>0) {
    return '刚刚'
  } else if (diff < 60 * 60 && diff>0) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
    // } else if (diff < 3600 * 24) {
    //   return Math.ceil(diff / 3600) + '小时前'
  } else if (target.getFullYear() === now.getFullYear()) {
    if (
      target.getMonth() === now.getMonth() &&
      target.getDate() === now.getDate()
    ) {
      return dayjs(target).format('HH:mm')
    } else {
      return dayjs(target).format('M/D HH:mm')
    }
  } else {
    return dayjs(target).format('YYYY/MM/DD HH:mm')
  }
}

/**
 * 将时间转换成iso1806时间格式（暂时舍弃毫秒）
 * @param d
 */
export function toISOLocal(d:Date) {
  const z:(p:number)=>string = n =>  ('0' + n).slice(-2);
  const zz = n => ('00' + n).slice(-3);
  let off = d.getTimezoneOffset();
  const sign = off > 0? '-' : '+';
  off = Math.abs(off);

  return d.getFullYear() + '-'
    + z(d.getMonth()+1) + '-' +
    z(d.getDate()) + 'T' +
    z(d.getHours()) + ':'  +
    z(d.getMinutes()) + ':' +
    z(d.getSeconds()) +
    // 后台暂时不支持毫秒
    // + '.' +
    // zz(d.getMilliseconds()) +
    sign + z(off/60|0) + ':' + z(off%60);
}

export const firstDayOfWeek = ():Date=>{
  const date = new Date()
  date.setDate(date.getDate()-date.getDay()+1)
  return date
}

export const firstDayOfMonth = ():Date=>{
  const date = new Date()
  date.setDate(1)
  return date
}

export const firstDayOfSeason = ():Date=>{
  const date = new Date()
  if(date.getMonth()<3){
    date.setMonth(0,1)
  }else if(date.getMonth()<6){
    date.setMonth(3,1)
  }else if(date.getMonth()<9){
    date.setMonth(6,1)
  }else {
    date.setMonth(9,1)
  }
  return date
}

export const firstDayOfYear = ():Date=>{
  const date = new Date()
  date.setMonth(0,1)
  return date
}

export const todayEnd = (): Date => {
  const date = new Date()
  date.setHours(23, 59, 59, 999)
  return date
}
export const isValidDate = (date: object): boolean => {
  return date instanceof Date && !isNaN(date.getTime())
}
